import RegistrationButton from './RegistrationButton';
export default RegistrationButton;
